import { Download } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PREFIX = 'WOrderDownloadPdfButton';

const classes = {
  button: `${PREFIX}-button`,
};
const StyledGrid = styled('div')(({ theme }) => ({
  [`& .${classes.button}`]: {
    padding: '0px',
    background: '#FFFFFF',
    border: '1px solid rgba(0, 125, 255, 0.5)',
    borderRadius: '4px',
    color: '#007DFF',
    minWidth: '36px',
    minHeight: '36px',
    '&:hover': {
      backgroundColor: ' rgba(0,125,255,0.08) ',
      boxShadow: 'none',
    },
  },
}));

const WOrderDownloadPdfButton = ({ onClickDownload }) => {
  const { t } = useTranslation('workOrdersTable');
  return (
    <StyledGrid>
      <Tooltip
        arrow
        title={t('detail.downloadPdfButton.title')}
        placement={'bottom'}
      >
        <Button
          size="small"
          className={classes.button}
          onClick={onClickDownload}
        >
          <Download />
        </Button>
      </Tooltip>
    </StyledGrid>
  );
};

export default WOrderDownloadPdfButton;
